import { render, staticRenderFns } from "./FS_Special.vue?vue&type=template&id=73120a74&"
import script from "./FS_Special.vue?vue&type=script&lang=js&"
export * from "./FS_Special.vue?vue&type=script&lang=js&"
import style0 from "./FS_Special.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports